import { render, staticRenderFns } from "./radio-button.vue?vue&type=template&id=6a2c14b6&scoped=true"
import script from "./radio-button.vue?vue&type=script&lang=js"
export * from "./radio-button.vue?vue&type=script&lang=js"
import style0 from "./radio-button.vue?vue&type=style&index=0&id=6a2c14b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2c14b6",
  null
  
)

export default component.exports